import NaeTopNavbar from './NaeTopNavbar'

export default { NaeTopNavbar }
